var _g, _g2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMoneyBag3 = function SvgMoneyBag3(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 111.508 140.852",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 288"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    fill: "#2455ef",
    "data-name": "Path 4271",
    d: "M69.604 36.113a2.934 2.934 0 00-2.113-.9H44.017a2.934 2.934 0 00-2.113.9c-4.29 4.443-41.9 43.9-41.9 60.725 0 24.274 25.013 44.016 55.754 44.016s55.754-19.743 55.754-44.016c-.004-16.825-37.618-56.284-41.908-60.725z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    fill: "#2455ef",
    "data-name": "Path 4272",
    d: "M93.168 3.926c-4.889-5.528-17.606 1.725-24.907 6.638C64.915 5.81 59.962 0 55.754 0s-9.161 5.81-12.506 10.564C35.965 5.646 23.223-1.608 18.341 3.926A7.39 7.39 0 0016.579 9.6c.945 10.869 23.07 28.834 25.588 30.841a2.934 2.934 0 001.849.646h23.475a2.934 2.934 0 001.831-.64C71.84 38.434 93.971 20.493 94.91 9.606a7.37 7.37 0 00-1.742-5.68z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 289"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2455ef",
    "data-name": "Path 4273",
    d: "M79.229 41.082h-46.95a2.934 2.934 0 110-5.869H79.23a2.934 2.934 0 110 5.869z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2455ef",
    "data-name": "Path 4274",
    d: "M55.754 117.377a13.586 13.586 0 01-14.672-10.928 2.945 2.945 0 115.869-.493c.258 3.063 4.208 5.552 8.8 5.552 4.777 0 8.8-2.688 8.8-5.869 0-2.864-2.782-4.7-8.75-5.81l-.64-.117c-9.525-1.761-14.085-5.652-14.085-11.679a13.5 13.5 0 0114.672-11.738A13.586 13.586 0 0170.42 87.223a2.945 2.945 0 11-5.869.493c-.246-3.063-4.2-5.552-8.8-5.552-4.777 0-8.8 2.688-8.8 5.869 0 2.864 2.788 4.7 8.762 5.81l.646.123c9.508 1.761 14.085 5.646 14.085 11.679a13.5 13.5 0 01-14.69 11.732z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2455ef",
    "data-name": "Path 4275",
    d: "M55.754 123.245a2.935 2.935 0 01-2.934-2.935V73.36a2.935 2.935 0 115.869 0v46.951a2.935 2.935 0 01-2.935 2.934z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoneyBag3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/money-bag3.d4c5fed5.svg";
export { ForwardRef as ReactComponent };